import Page from "@/components/Page"
import BackButton from "@/components/BackButton"

const SMART_GLUCOSE_METER_YOUTUBE_URL =
  "https://youtube.com/embed/ERUO1TRr6Bk?autoplay=0"

const ONBOARDING_INTRODUCTION_VIMEO_URL =
  "https://player.vimeo.com/video/949182782"

const InstructionVideosPage = () => (
  <Page showAppbar={false}>
    <BackButton />
    <div className="mt-4 flex flex-col gap-6 pb-2">
      <section className="flex flex-col gap-2">
        <h2 className="text-base font-semibold text-primary-contrast">
          View the video below to understand how to use the blood glucose monitor
        </h2>
        <div className="aspect-video w-full overflow-hidden rounded-lg border border-secondary bg-black">
          <iframe
            allowFullScreen
            src={SMART_GLUCOSE_METER_YOUTUBE_URL}
            title="Blood glucose monitor instructions"
            className="h-full w-full border-0"
          />
        </div>
      </section>
      <section className="flex flex-col gap-2">
        <h2 className="text-base font-semibold text-primary-contrast">
          Bloomlife introduction
        </h2>
        <div className="aspect-video w-full overflow-hidden rounded-lg border border-secondary bg-black">
          <iframe
            allowFullScreen
            src={ONBOARDING_INTRODUCTION_VIMEO_URL}
            title="Welcome to Bloomlife Connects"
            className="h-full w-full border-0"
          />
        </div>
      </section>
    </div>
  </Page>
)

export default InstructionVideosPage
